import { apiServiceInstance } from '@/core/helpers/utils';
import { ICapSuaChuaFilterParams } from '@/core/interfaces/ApiRequest.interface';
import {
    ApiResponse,
    ICapSuaChuaResponseBase,
    IDonViPdfExtra,
    PaginationResponseBase,
} from '../interfaces/ApiResponses';

export class CapSuaChuaService {
	static async listAll({
		s = '',
		per_page = 200,
	}: {
		s?: string;
		per_page?: number;
	} = {}): Promise<{
		items: ICapSuaChuaResponseBase[];
		extra?: IDonViPdfExtra;
	}> {
		const allItems: ICapSuaChuaResponseBase[] = [];
		let page = 1;
		let total = Infinity;
		let extra: IDonViPdfExtra | undefined;

		while (allItems.length < total) {
			const { data: response } = await CapSuaChuaService.list({
				current_page: page,
				per_page,
				s,
			});
			const {
				data: { data, total: totalItems },
			} = response;

			if (page === 1) {
				extra = response.extra as IDonViPdfExtra | undefined;
			}

			total = totalItems;
			allItems.push(...data);

			if (!data.length) break;
			page += 1;
		}

		return { items: allItems, extra };
	}

	static list({ current_page, per_page, s }: ICapSuaChuaFilterParams): Promise<{
		data: ApiResponse<PaginationResponseBase<ICapSuaChuaResponseBase>>;
	}> {
		return apiServiceInstance().vueInstance.axios.get(
			'/api/v1/cap-sc/danh-sach',
			{
				params: {
					page: current_page || 1,
					...(s && { s }),
				},
				headers: {
					perpage: per_page || 30,
				},
			},
		);
	}

	static get(id: number): Promise<{
		data: ApiResponse<ICapSuaChuaResponseBase>;
	}> {
		return apiServiceInstance().vueInstance.axios.get(
			`/api/v1/cap-sc/chi-tiet/${id}`,
		);
	}

	static createOrUpdate({
		ten_cap_sc,
		ten_viet_tat,
		matk,
		mact,
		tentk,
		mo_ta,
		id_cap_sc,
	}: {
		ten_cap_sc: string;
		ten_viet_tat: string;
		matk: string;
		mact?: string;
		tentk: string;
		mo_ta?: string;
		id_cap_sc?: number;
	}): Promise<{
		data: ApiResponse<ICapSuaChuaResponseBase>;
	}> {
		apiServiceInstance().vueInstance.axios.defaults.headers.common[
			'Content-Type'
		] = 'multipart/form-data';
		const bodyFormData = new FormData();

		const isCreating = !id_cap_sc;

		const url = isCreating
			? `/api/v1/cap-sc/tao-moi`
			: `/api/v1/cap-sc/cap-nhat/${id_cap_sc}`;

		bodyFormData.append('ten_cap_sc', ten_cap_sc);

		bodyFormData.append('ten_viet_tat', ten_viet_tat);

		bodyFormData.append('tk_ketoan[matk]', matk);

		bodyFormData.append('tk_ketoan[tentk]', tentk);

		if (mact) {
			bodyFormData.append('tk_ketoan[mact]', mact);
		}

		if (mo_ta) {
			bodyFormData.append('mo_ta', mo_ta);
		}

		return apiServiceInstance().vueInstance.axios.post(url, bodyFormData);
	}

	static delete(id: number) {
		return apiServiceInstance().vueInstance.axios.post(`/api/v1/cap-sc/xoa/${id}`);
	}
}
